import { ReactElement } from 'react';

type LoginErrorMessageProps = {
  error: Error;
};

const shouldShowAdBlockerHint = (message: string): boolean =>
  message.includes('Failed to fetch');

export const LoginErrorMessage = ({
  error,
}: LoginErrorMessageProps): ReactElement => {
  return (
    <>
      <span>{error.message}</span>
      {shouldShowAdBlockerHint(error.message) && (
        <>
          <br />
          <span>
            If you use an ad blocker or privacy extension, add Confidence to
            your allow list and try again. If this continues, check your VPN or
            network access, or contact support.
          </span>
        </>
      )}
    </>
  );
};
